var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 9.03333L5.14 9.39333C5.72287 9.65804 6.35269 9.80381 6.99259 9.82213C7.63249 9.84045 8.26961 9.73093 8.86667 9.5C9.31856 9.31985 9.80347 9.23741 10.2895 9.25809C10.7756 9.27878 11.2517 9.40212 11.6867 9.62L13.6867 10.6067V3.75333L12.3 3.08667C11.6959 2.78558 11.0349 2.61567 10.3604 2.5881C9.68601 2.56052 9.01336 2.6759 8.38667 2.92667C7.95044 3.09541 7.48458 3.17413 7.01712 3.15809C6.54967 3.14205 6.0903 3.03158 5.66667 2.83333L4.33333 2.24V1.5H3V14.8333H4.33333V9.03333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.943f5129d1563b9cd4284535b16bdb65.svg";
export { ForwardRef as ReactComponent };